import * as Types from './actions.types'

export function getPublicProfile(id) {
  return {type: Types.PUBLICPROFILE_GET, id}
}

export function getPublicProfileSuccess(publicProfile) {
  return {type: Types.PUBLICPROFILE_GET_SUCCESS, payload: publicProfile}
}

export function getPublicProfileFailure(error) {
  return {type: Types.PUBLICPROFILE_GET_FAILURE, error}
}

export function getProfile() {
  return {type: Types.PROFILE_GET}
}

export function getProfileSuccess(profile) {
  return {type: Types.PROFILE_GET_SUCCESS, payload: profile}
}

export function getProfileFailure(error) {
  return {type: Types.PROFILE_GET_FAILURE, error}
}

export function getRecimee() {
  return {type: Types.RECIMEE_GET}
}

export function getRecimeeSuccess(recimeeId) {
  return {type: Types.RECIMEE_GET_SUCCESS, payload: recimeeId}
}

export function getRecimeeFailure(error) {
  return {type: Types.RECIMEE_GET_FAILURE, error}
}

export function createProfile(profile) {
  return {type: Types.PROFILE_CREATE, payload: profile}
}

export function createProfileSuccess(profile) {
  return {type: Types.PROFILE_CREATE_SUCCESS, payload: profile}
}

export function createProfileFailure(error) {
  return {type: Types.PROFILE_CREATE_FAILURE, error}
}

export function createProfileInit() {
  return {type: Types.PROFILE_CREATE_INIT}
}

export function initProfileEdit() {
  return {type: Types.PROFILE_EDIT_INIT}
}

export function updateProfile(update) {
  return {type: Types.PROFILE_UPDATE, payload: update}
}

export function saveProfile(id, payload) {
  return {type: Types.PROFILE_SAVE, id, payload}
}

export function toggleProfileEdit() {
  return {type: Types.PROFILE_TOGGLE_EDIT}
}

export function follow(id) {
  return {type: Types.PROFILE_FOLLOW, id}
}

export function followSuccess() {
  return {type: Types.PROFILE_FOLLOW_SUCCESS}
}

export function followFailure(error) {
  return {type: Types.PROFILE_FOLLOW_FAILURE, error}
}

export function unfollow(id, index) {
  return {type: Types.PROFILE_UNFOLLOW, id, index}
}

export function unfollowFollower(user, index) {
  return {type: Types.PROFILE_UNFOLLOW_FOLLOWER, user, index}
}

export function unfollowSuccess(index) {
  return {type: Types.PROFILE_UNFOLLOW_SUCCESS, index}
}

export function unfollowFailure(error) {
  return {type: Types.PROFILE_UNFOLLOW_FAILURE, error}
}

export function saveProfileSuccess(profile) {
  return {type: Types.PROFILE_SAVE_SUCCESS, payload: profile}
}

export function saveProfileFailure(error) {
  return {type: Types.PROFILE_SAVE_FAILURE, error}
}

export function changePassword(currentPassword, newPassword) {
  return {type: Types.PROFILE_CHANGE_PASSWORD, currentPassword, newPassword}
}

export function changePasswordSuccess(response) {
  return {type: Types.PROFILE_CHANGE_PASSWORD_SUCCESS, response}
}

export function changePasswordFailure(error) {
  return {type: Types.PROFILE_CHANGE_PASSWORD_FAILURE, error}
}

export function updateChangePassword(update) {
  return {type: Types.PROFILE_CHANGE_PASSWORD_UPDATE, update}
}

export function getCategoriesOfProfile(id) {
  return {type: Types.GET_CATEGORIES_OF_PROFILE, id}
}

export function getCategoriesOfProfileSuccess(categories) {
  return {type: Types.GET_CATEGORIES_OF_PROFILE_SUCCESS, categories}
}
export function getCategoriesOfProfileFailure(error) {
  return {type: Types.GET_CATEGORIES_OF_PROFILE_FAILURE, error}
}

export function clearNotifications() {
  return {type: Types.CLEAR_NOTIFICATIONS}
}
